export enum ForecastSeriesTypesEnum {
  PREDICTION = 'PREDICTION',
  AGGREGATED_PREDICTION = 'AGGREGATED_PREDICTION',
  PREDICTION_HISTORY = 'PREDICTION_HISTORIY',
  AGGREGATION = 'AGGREGATION',
  ACTUALS = 'ACTUALS',
}
